const initialState = {
  loading: true
}

const ui = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_MENU_PAGE':
        return Object.assign({}, state, {
          current_page: action.payload
        })
      case 'SET_LOADING':
        return Object.assign({}, state ,{
          loading: action.payload
        })
      case 'ENABLE_NEXT_BUTTON':
        return Object.assign({}, state ,{
          enableNextButton: action.payload
        })
      case 'SHOW_MENU':
        return Object.assign({}, state ,{
          showMenu: action.payload
        })
      default:
        return state
    }
  }
  
  export default ui